import React from 'react';
import { ADMIN_DASHBOARD, ADMIN_PENDING_HIRES } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';

const ImportPendingHiresPage = React.lazy(() => import('../../../pages/Admin/ImportPendingHires/ImportFieldValues'));

export default [
  {
    group: ADMIN,
    route: '/administration/import-data',
    area: ADMIN_PENDING_HIRES,
    component: ImportPendingHiresPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_DASHBOARD,
    hasNavBar: false,
  },
];
